import styled, { css } from "styled-components";
import { hexToRgba } from "@icarros/utils-react";
import { ids } from "@icarros/theme-react";
const { color, text, size, opacity } = ids || {};
const inputDisabled = css `
  color: ${color.action.disabled.ids_color_action_disabled_variant};
  border-radius: ${size.corner_radius.ids_size_cornerRadius_tooltip};
  cursor: not-allowed;
`;
const labelDisabled = css `
  background: ${hexToRgba(color.action.disabled.ids_color_action_disabled_variant, opacity.ids_opacity_soft)};
  cursor: not-allowed;
`;
export const StyledContainer = styled.div `
  position: relative;
  padding: 0;
`;
export const StyledTextFieldContainer = styled.div `
  display: flex;
  align-items: flex-end;
  position: relative;
  padding-left: 8px;
  min-height: 64px;
  ${({ isDisabled }) => isDisabled &&
    `
      border-radius: ${size.general.ids_size_general_4x}
      ${size.general.ids_size_general_4x} 0 0;
      background: ${hexToRgba(color.action.disabled.ids_color_action_disabled_base, opacity.ids_opacity_soft)};
    `}
`;
export const StyledLabel = styled.label `
  pointer-events: none;
  transform-origin: left top;
  transition: 200ms ease all;
  position: absolute;
  bottom: 7px;
  width: 100%;
  ${({ isDisabled }) => isDisabled && labelDisabled}
  &.active {
    transform: translateY(-25px);
  }
`;
export const StyledTextField = styled.input `
  display: flex;
  font-size: 100%;
  line-height: 25px;
  text-shadow: none;
  ${text.label.ids_textStyle_label_medium_regular};
  caret-color: ${color.action.primary.ids_color_action_primary_base};
  border: 0;
  color: #000;
  flex: 1 1 auto;
  order: 2;
  padding-bottom: 7px;
  ${({ isDisabled }) => isDisabled && inputDisabled}
  ${({ withIcon }) => withIcon && `padding-right: 40px`};

  &:focus {
    outline: 0;
  }
`;
export const StyledDividerContainer = styled.div `
  display: flex;
  position: relative;
`;
export const StyledIcon = styled.div `
  position: absolute;
  bottom: ${({ iconButton }) => iconButton ? "0" : "8px"};
  right: ${({ iconButton }) => iconButton ? "0" : "8px"};
  button {
    height: unset;
    padding: 8px;
  }
`;
export const StyledHelperTextContainer = styled.div `
  margin-top: 2px;
`;
export const StyledHelperTextIcon = styled.span `
  margin-right: 5px;
`;
//# sourceMappingURL=InputTextField.style.js.map